<template>
  <div id="myDateShow">
    <div class="title">{{label.id?"修改":"新增"}} 商品标签</div>
    <div id="dataShow">
      <div class="line">
        <div class="key">标签名</div>
        <div class="value">
          <el-input class="w500" v-model="label.labelName" placeholder="请填写标签名称"></el-input>
        </div>
      </div>
      <div class="line">
        <div class="key"></div>
        <div class="value">
          <el-button type="primary" size="medium" @click="submit">提交信息</el-button>
        </div>
      </div>
      <div class="line"></div>
    </div>
    <div class="but">
      <el-button type="danger" size="small" @click="backClick">返回</el-button>
    </div>
  </div>
</template>

<script>
  import {getLabelById, newVue, updateLabel} from "../../network/label";

  export default {
    name: "LabelInsert",
    data(){
      return{
        label: {},
        labelId: '',
      }
    },
    created() {
      newVue.obj = this;
      this.common.HeaderLocationTwo.href = "/skuLabel/list";
      this.common.HeaderLocationTwo.name = "商品标签管理";
      this.common.HeaderLocationThree.name = "新增or修改商品标签"
      if (this.$route.params.id!=null){
        this.labelId = this.$route.params.id;

        getLabelById(this.labelId).then(res => {
          this.label = res.data;
        })
      }


    },
    methods: {
      backClick(){
        this.$router.push("../list");
      },
      submit(){
        updateLabel(this.label).then(res => {
          console.log(res);
        })
      }
    }
  }
</script>

<style scoped>
  @import "../../assets/css/data.css";
  .w500{
    width: 500px;
  }
</style>
